export const onCallDataLayer = (event) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
  });
};

export default null;
